import React from "react";
type MarqueeProps = {
  items: string[];
  className?: string;
  /** Seconds for one full loop. Higher is slower. */
  durationSeconds?: number;
};
export function Marquee({
  items,
  className = "",
  durationSeconds
}: MarqueeProps) {
  const sequence = [...items, ...items];
  return <div className={`marquee-mask group relative overflow-hidden ${className}`} aria-hidden="true" data-id="element-324" data-mp="2dkuef2lmgv3d">
      {/*
        Spacing lives on each item as padding rather than a flex gap. A gap adds an extra
        half-step across the seam, which makes the -50% loop land off by half a gap and jump.
       */}
      <div className="marquee-track flex w-max items-center" style={durationSeconds ? {
      animationDuration: `${durationSeconds}s`
    } : undefined} data-id="element-325" data-mp="319m1xgo9op9t">
        {sequence.map((item, index) => <span key={`${item}-${index}`} className="flex shrink-0 items-center gap-10 pr-10 font-mono text-xs uppercase tracking-[0.2em] text-white/80 md:gap-16 md:pr-16 md:text-sm" data-id="element-326" data-mp="1pv8hklsq2ryj" data-mpi={index}>
            {item}
            <span className="dot-blink h-1.5 w-1.5 shrink-0 rounded-full bg-[#54f6c6]" style={{
          animationDelay: `${index % 5 * 0.24}s`
        }} data-id="element-327" data-mp="2ti4a41qbkebn" />
          </span>)}
      </div>
    </div>;
}